function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import { ToastContainer } from 'react-toastify';
export { toast } from 'react-toastify';
export const ToastProvider = ({
  className = '',
  style = {},
  ...rest
}) => /*#__PURE__*/React.createElement(ToastContainer, _extends({
  toastClassName: "toast",
  className: className,
  style: style
}, rest));
ToastProvider.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};